<template>
  <div class="row">

    <div class="col-xs-12">
      <panel-block>
        <h2 slot="title">
          Error Logs
        </h2>
        <li slot="toolbar-start" class="dropdown">
          <a 
            v-if="showResolved === false"
            v-on:click.prevent="toggleShowResolved()"
            href="#" 
            class="dropdown-toggle" 
            title="Show Resolved Log Items"
          >
            <i 
              class="fa fa-eye"
              >
            </i>
          </a>
          <a 
            v-else
            v-on:click.prevent="toggleShowResolved()"
            href="#" 
            class="dropdown-toggle" 
            title="Hide Resolved Log Items"
          >
            <i 
            class="fa fa-eye-slash"
            >
            </i>
          </a>
        </li>
        <div slot="content">
          <div class="row table-row hidden-xs hidden-sm hidden-md">
            <div 
              v-if="!allResolved"
              class="col-sm-12"
            >
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-1"><strong></strong></div>
                    <div class="col-lg-3 col-xs-8"><strong>Time</strong></div>
                    <div class="col-lg-7"><strong>Title/Message</strong></div>
                    <div class="col-lg-1"><strong class="pull-right">Status</strong></div>
                  </div>
                </div>
                <div class="col-lg-2 col-xs-2">
                  <div class="row">
                    <div class="col-md-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="log" class="col-xs-12 table table-hover">
              <div 
                v-for="item in logFiltered"
                :class="[
                  'row',
                  item.status === 4 ? 'success' : ''
                ]"
              >
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="row">
                        <div class="col-md-2 col-xs-12 pull-right">
                          <div class="row">
                            <div class="col-md-8">

                              <dropdown :text="statusList[item.status - 1].title" class="btn-block" size="sm" :type="statusList[item.status - 1].style">
                                <li class="btn-block" v-for="status in statusList">
                                  <button 
                                    v-on:click.prevent="changeStatus(item, status)" 
                                    class="btn-block btn-link" 
                                  >
                                    {{ status.title }}
                                  </button>
                                </li>
                              </dropdown>

                            </div>

                            <div class="col-md-3 pull-right">
                              <button
                                v-if="typeof detailItem === 'object' && detailItem.pk === item.pk"
                                v-on:click="closeDetail()"
                                :class="[
                                  'btn btn-success',
                                  typeof details[item.pk] !== 'undefined' && details[item.pk].length === 0 ? 'disabled' : ''
                                ]"
                              >
                                <i
                                  v-if="typeof details[item.pk] === 'undefined'"
                                  class="fa fa-spin fa-spinner"
                                ></i>
                                <i
                                  v-else-if="typeof details[item.pk] !== 'undefined' && details[item.pk].length > 0"
                                  class="fa fa-chevron-up"
                                ></i>
                                <i
                                  v-else
                                  class="fa fa-spin fa-dot-circle-o"
                                ></i>
                              </button>
                              <button
                                v-else
                                v-on:click="openDetail(item)"
                                :class="[
                                  'btn btn-success',
                                  typeof details[item.pk] !== 'undefined' && details[item.pk].length === 0 ? 'disabled' : ''
                                ]"
                              >
                                <i 
                                  v-if="typeof details[item.pk] === 'undefined' || details[item.pk].length > 0"
                                  class="fa fa-chevron-down"
                                ></i>
                                <i
                                  v-else
                                  class="fa fa-spin fa-dot-circle-o"
                                ></i>
                              </button>
                            </div>
                          </div>


                        </div>

                        <div class="col-lg-3 col-xs-12">
                          {{ item.inserted | moment("MMM DD hh:mm:ss") }} 
                        </div>
                        <div class="col-lg-5 col-xs-12">
                          <strong>{{ item.title }}</strong>
                          <br />
                          {{ item.message }}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="typeof details[item.pk] !== 'undefined' && detailItem.pk === item.pk"
                  class="col-md-12"
                  style="background-color: #fffff;"
                >
                  <div
                    class="row"
                    v-for="row in details[item.pk]"
                    style="border-bottom: 1px solid #000000; margin-top: 10px; padding-bottom: 10px;"
                  >
                    <div
                      class="col-xs-12 col-md-1"
                    >
                      {{ row.dt | moment("MMM DD hh:mm:ss") }} 
                    </div>
                    <div
                      class="col-xs-12 col-md-1"
                    >
                      {{ row.server }} 
                    </div>
                    <div
                      class="col-xs-12 col-md-2"
                    >
                      {{ row.program }} 
                    </div>
                    <div
                      class="col-xs-12 col-md-1"
                    >
                      Line: {{ row.linenum }} 
                    </div>
                    <div
                      class="col-xs-12 col-md-7"
                    >
                      {{ row.message }} 
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="text-center" v-else>
              <i class="fa fa-4x fa-spin fa-spinner loader"> </i>
            </div>
          </div>
          <div 
            v-if="allResolved && log.length > 0 && !showResolved"
            class="text-center"
          >
            <button
              v-on:click.prevent="toggleShowResolved()" 
              class="btn btn-success"
            >
              Show Resolved
            </button>
          </div>

        </div>
      </panel-block>
    </div>
  </div>
</template>
<script>
import { dropdown } from 'vue-strap'
import { mapActions } from 'vuex'

import Panel from '@/components/Layout/Panel.vue'

export default {
  name: 'Logs',
  components: {
    dropdown,
    'panel-block': Panel
  },
  data () {
    return {
      allResolved: true,
      detailItem: '',
      details: {},
      log: {},
      // domain: this.$store.app.domain.api10,
      showResolved: false,
      statusList: [
        { pk: 1, title: 'New', style: 'danger' },
        { pk: 2, title: 'Acknowledged', style: 'warning' },
        { pk: 3, title: 'Investigating', style: 'info' },
        { pk: 4, title: 'Resolved', style: 'success' }
      ]
    }
  },
  mounted () {
    this.getErrorLogs()
  },
  methods: {
    ...mapActions([
      'buildApiReqeust',
      'updateUser'
    ]),
    openDetail (item) {
      this.$set(this, 'detailItem', item)
      this.getDetail(item)
    },
    getDetail (item) {
      this.$log('error', item).detail().then(response => {
        this.$set(this.details, item.pk, response)
      })
    },
    closeDetail () {
      this.$set(this, 'detailItem', '')
    },
    toggleShowResolved () {
      if (this.showResolved === true) {
        this.$set(this, 'showResolved', false)
        return false
      }
      this.$set(this, 'showResolved', true)
    },
    getErrorLogs (pk = null) {
      this.$set(this, 'log', '')
      this.$log('error').all().then(response => {
        this.parseLogs(response)
      })
    },
    callApi (request, callback = null) {
      this.$http[request.type](request.url, request.params).then(response => {
        if (callback === null) {
          return 'success'
        }
        this[callback](response)
      })
    },
    parseLogs (data) {
      data.reverse()
      for (let i = 0; data.length > i; i++) {
        if (data[i].status === 0) {
          data[i].status = 1
        }
        if (data[i].status !== 4) {
          this.getDetail(data[i])
        } else {
          this.$set(this, 'allResolved', true)
        }
      }
      this.$set(this, 'log', data)
    },
    changeStatus (item, status) {
      this.$log('error', item).set('status', status.pk).save().then(response => {
        // let i = this.log.indexOf(item)
        // this.log[i].status = status.pk
      })
    }
  },
  computed: {
    logFiltered () {
      if (this.showResolved === true) {
        return this.log
      }

      let list = []
      for (let i = 0; this.log.length > i; i++) {
        if (this.log[i].status === 4) {
          continue
        }
        list.push(this.log[i])
      }
      return list
    }
  }
}

</script>

<style scoped>
.table-row > div {
  padding-top: 8px;
  padding-bottom: 8px;
}
.table-hover > .row {
  padding-top: 8px;
  padding-bottom: 8px;
  border-top: 1px solid #ddd;
}
.table-hover > .row:nth-child(odd){
  background-color: #f9f9f9;
}
.table-hover > .row.success {
  background-color: #dff0d8;
}

div.btn-block > button {
  display: block;
  width: 100%;
}

.row.hideSuccess {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Logs.vue?dec70c90